import { render, staticRenderFns } from "./ShopBasket.vue?vue&type=template&id=510ef419&"
import script from "./ShopBasket.vue?vue&type=script&lang=js&"
export * from "./ShopBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports